import type { ChatSessionMessage } from '../model/types'

import { AnimatePresence, motion } from 'framer-motion'
import { SparklesIcon } from 'lucide-react'
import Markdown from 'markdown-to-jsx'

import { cn } from '@/shared/lib/utils'

import ChatMessageActions from './ChatMessageActions'
import { ChatMessageArtifactVideo } from './ChatMessageVideoArtifact'

export default function ChatMessage({
	message,
}: {
	message: ChatSessionMessage
}) {
	return (
		<AnimatePresence>
			<motion.div
				data-testid={`message-${message.sender}`}
				className='group/message mx-auto w-full max-w-3xl px-3'
				initial={{ y: 5, opacity: 0 }}
				animate={{ y: 0, opacity: 1 }}
				data-role={message.sender}
			>
				<div
					className={cn(
						'flex w-full gap-3 group-data-[role=user]/message:ml-auto group-data-[role=user]/message:max-w-2xl',
						'group-data-[role=user]/message:w-fit'
					)}
				>
					{message.sender === 'assistant' && (
						<div className='flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary dark:bg-primary-900/20'>
							<SparklesIcon className='size-4' />
						</div>
					)}

					<div className='flex w-full flex-col gap-1'>
						<div
							data-testid='message-content'
							className={cn(
								'flex shrink-0 grow basis-0 flex-col gap-4 text-sm',
								{
									'rounded-lg bg-slate-700/10 px-3 py-2 dark:bg-white/10':
										message.sender === 'user',
								}
							)}
						>
							<Markdown className='prose prose-sm prose-stone dark:prose-invert prose-img:rounded-xl'>
								{message.text}
							</Markdown>
							{message.artifacts?.map(
								(artifact) =>
									artifact.type == 'video' && (
										<ChatMessageArtifactVideo
											id={artifact.id}
											key={artifact.id}
										/>
									)
							)}
						</div>
						{!message.is_system && message.sender !== 'user' && (
							<ChatMessageActions message={message} vote={message.reaction} />
						)}
					</div>
				</div>
			</motion.div>
		</AnimatePresence>
	)
}
